// BroadcastChannel is used to notify other tabs of changes to property status, etc.

export const propertySyncChannel = new BroadcastChannel('aro-property-sync');

export const PropertyBroadcastMessageTypes = {
    PropertyUpdated: 'property-updated',
    ProjectUpdated: 'project-updated',
};
export const broadcastPropertyUpdate = (type, propertyId) => {
    console.log('Broadcasting property update', { type, propertyId });
    propertySyncChannel.postMessage({ type });
};
